import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import Bill from './Bill';
import ShadowBoxTable from '../ShadowBoxTable';

const BillsTable = ({
  bills,
  onUpdatePaidDate,
  bankAccountId,
  selectedBills,
  onSelect,
  onDelete,
  showNotes = true,
  showPaidColumn = true,
  showAllBills = false,
  bankAccounts = []
}) => {
  // Mobile detection state
  const [isMobilePortrait, setIsMobilePortrait] = useState(false);

  // Check if device is mobile portrait
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // Phone detection: either portrait (width <= 480) or landscape (height <= 480 && width <= 896)
      const isPhonePortrait = width <= 480;
      const isPhoneLandscape = height <= 480 && width <= 896;
      setIsMobilePortrait(isPhonePortrait || isPhoneLandscape);
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return (
    <ShadowBoxTable>
      <Table striped className="bills-table" style={{ textAlign: "center", verticalAlign: "middle" }}>
        <thead>
          <tr>
            {isMobilePortrait ? (
              // Mobile Portrait Headers
              <>
                <th style={{ textAlign: 'left', width: 'calc(100% - 80px)' }}>Bill Details</th>
                <th style={{ width: '80px', textAlign: 'center' }}>Action</th>
              </>
            ) : (
              // Desktop/Landscape Headers
              <>
                <th>Bill</th>
                <th>Amount</th>
                <th>Due Date</th>
                {showPaidColumn && <th>Date Paid</th>}
                {showAllBills && <th>Bank Account</th>}
                <th style={{ width: '40px' }}></th>
                {showNotes && <th style={{ width: '40px' }}>Notes</th>}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {bills.length > 0 ? (
            bills.map(bill => (
              <Bill
                key={bill.id}
                bill={bill}
                onUpdatePaidDate={onUpdatePaidDate}
                bankAccountId={bankAccountId}
                isSelected={selectedBills.includes(bill)}
                onSelect={onSelect}
                onDoubleClick={(bill) => onSelect(bill, { shiftKey: false })}
                onDelete={onDelete}
                showAllBills={showAllBills}
                bankAccounts={bankAccounts}
              />
            ))
          ) : (
            <tr>
              <td colSpan={isMobilePortrait ? 2 : (showNotes ? (showAllBills ? 7 : 6) : (showAllBills ? 6 : 5))}>
                Loading Bills and Pays (if you're lucky)
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ShadowBoxTable>
  );
};

export default BillsTable;
